import { mapActions } from 'vuex'
import WidgetStepPreview
  from '@components/Widgets/_global/WidgetStepPreview/WidgetStepPreview.vue'
import { CAMPAIGN_TYPE } from '@meta/campaignConstants'

export default {
  name: 'WidgetItems',
  components: { WidgetStepPreview },
  computed: {
    targetWidgetID() {
      return this.$store.state.campaign.widget.targetWidgetID
    },
    widgetItems() {
      return this.$store.getters['campaign/widget/getWidgetItems']
    },
    widgetItemsList() {
      return this.$store.getters['campaign/widget/getWidgetItemsList']
    },
    isABTest() {
      return this.widgetItemsList.length > 1
    }
  },
  data() {
    return {
      isWidgetMenuModalOpen: false,
    }
  },
  methods: {
    ...mapActions('campaign', ['partialSaveCampaign']),
    ...mapActions('campaign/widget',
      ['setTargetWidget', 'cloneWidget', 'deleteWidget']),
    // toggleWidgetGalleryModal() {
    //   this.addStep()
    // },
    // triggerCloneWidget(id, index) {
    //   /* This function exists only because a direct @click trigger doesn't support
    //      passing object with vars e.g. cloneWidget({ id, index }) */
    //   this.cloneWidget({ id, index })
    // },
    triggerDeleteWidget(id, index) {
      this.$msgbox
        .confirm('Are you sure you\'d like to delete this widget?', 'Warning', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          type: 'warning',
        })
        .then(() => {
          this.deleteWidget({ id, index }).then(() => {
            this.partialSaveCampaign({ type: CAMPAIGN_TYPE.DEFAULT })
          })
        }).catch(() => {})
    },
    triggerWidgetMenuModalOpen() {
      this.$emit('trigger-toggle-modal')
    },
  },
}
